import React from "react"
import {Stack, styled, Typography, useTheme} from "@mui/material"
import {SegmentButton} from "./SegmentButton"
import {getOptions} from "../../../misc/widget-functions"

const SegmentButtonContainer = styled("div")(({theme}) => theme.SEGMENTBUTTON.container)

const SegmentButtonWidget = ({widget, value, onValueChange, disabled, triggerAction}) => {
    const options = getOptions(widget)
    const handleChange = newValue => {
        onValueChange(newValue)
    }
    const theme = useTheme()

    return (
        <Stack>
            {widget.text && (
                <Typography
                >
                    {widget.text}
                </Typography>
            )}
            <SegmentButtonContainer>
                {options?.map((entry) => (
                    <SegmentButton
                        key={entry.id}
                        onClick={valueOfButton => handleChange(valueOfButton)}
                        active={value}
                        value={entry.value}
                        label={entry.label}
                        disabled={disabled}
                    />
                ))}
            </SegmentButtonContainer>
        </Stack>
    )
}

export default SegmentButtonWidget
